package com.essntl.features.authentication.ui.auth

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.button.tinted.EsLargeTintedButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.esIconPainterResource
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun AuthScreenDemo(
    state: AuthState,
    validation: AuthValidation,
    onEvent: (AuthEvent) -> Unit,
) {
    val sendOtpButtonEnabled = remember(state.email) {
        state.email.isNotEmpty()
    }

    val loginButtonEnabled = remember(state.email, state.otp) {
        state.email.isNotEmpty() && state.otp.isNotEmpty()
    }

    val textFieldWidth = Modifier.fillMaxWidth(0.5f)

    Row(modifier = Modifier.fillMaxSize()) {
        Image(
            painter = esIconPainterResource(EsIcons.Logo),
            contentDescription = "Logo",
            modifier = Modifier.size(80.dp, 96.dp),
        )

        Box(modifier = Modifier.fillMaxHeight().weight(4f)) {
            Column(modifier = Modifier.fillMaxSize()) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween,
                    modifier = Modifier
                        .fillMaxWidth()
                        .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
                        .background(MaterialTheme.esColorScheme.bgSecondary)
                        .padding(
                            vertical = EsConstants.SectionVerticalPadding,
                            horizontal = EsConstants.SectionHorizontalPadding,
                        ),
                ) {
                    Text(
                        text = "Odia",
                        color = MaterialTheme.esColorScheme.textPrimary,
                        style = MaterialTheme.esTypography.h2Bold32,
                    )
                }

                Spacer(modifier = Modifier.height(1.spacing))

                Column(
                    verticalArrangement = Arrangement.Top,
                    horizontalAlignment = Alignment.CenterHorizontally,
                    modifier = Modifier
                        .fillMaxSize()
                        .clip(RoundedCornerShape(EsConstants.RoundedCornerSize))
                        .background(MaterialTheme.esColorScheme.bgSecondary)
                        .padding(5.spacing),
                ) {
                    Text(
                        text = "Hi, Login to the Essential",
                        color = MaterialTheme.esColorScheme.textPrimary,
                        style = MaterialTheme.esTypography.h2Bold32,
                    )

                    Spacer(modifier = Modifier.height(4.spacing))

                    Row(
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = textFieldWidth,
                    ) {
                        EsInput(
                            value = state.email,
                            state = validation.email.state,
                            onValueChange = {
                                validation.email.validate(it)
                                onEvent(AuthEvent.UpdateAuthFields(state.copy(email = it)))
                            },
                            placeholder = "Enter email",
                            modifier = Modifier.weight(1f),
                        )

                        Spacer(modifier = Modifier.width(2.spacing))

                        EsLargeTintedButton(
                            onClick = {
                                
                            },
                            loading = state.sendOtpSubmit.isLoading,
                            enabled = sendOtpButtonEnabled,
                            text = "Send me my OTP",
                            modifier = Modifier.width(200.dp),
                        )
                    }

                    Spacer(modifier = Modifier.height(.5.spacing))

                    Text(
                        text = "*You will be sent a one-time password to your email (OTP)",
                        color = MaterialTheme.esColorScheme.textPrimary,
                        style = MaterialTheme.esTypography.s2SemiBold16,
                        modifier = Modifier.fillMaxWidth(0.5f),
                    )

                    Spacer(modifier = Modifier.height(8.spacing))

                    Row(
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = textFieldWidth,
                    ) {
                        EsInput(
                            value = state.otp,
                            state = validation.loginForm.otp.state,
                            onValueChange = {
                                validation.loginForm.otp.validate(it)
                                onEvent(AuthEvent.UpdateAuthFields(state.copy(otp = it)))
                            },
                            placeholder = "Enter OTP code",
                            modifier = Modifier.weight(1f),
                        )
                        Spacer(modifier = Modifier.width(2.spacing))
                        EsLargePrimaryButton(
                            text = "Login",
                            loading = state.loginSubmit.isLoading,
                            onClick = {
                                if (validation.loginForm.validate())
                                    onEvent(AuthEvent.Login)
                            },
                            enabled = loginButtonEnabled,
                            modifier = Modifier.width(200.dp),
                        )
                    }
                }
            }
        }
    }
}